import type React from 'react';

import { Text } from '@change/ds-core-ui';

import type { AdvocateAvatarProps } from '../../types';

import { useAdvocateInfo } from './hooks';

export const AdvocateInfo: React.FC<AdvocateAvatarProps> = ({ hasAdvocatesState, petitionAdvocates }) => {
	const { title, subtitle } = useAdvocateInfo({ hasAdvocatesState, petitionAdvocates });

	return (
		<div className="flex flex-col">
			<Text variant="body" size="large" fontWeight="bold" className="text-typography-strong">
				{title}
			</Text>
			<Text variant="body" className="text-typography-weak">
				{subtitle}
			</Text>
		</div>
	);
};
